import * as React from "react";
import styled, { css } from "styled-components";
import { CouponItemProps } from "..";
import { CouponBtn } from "./CouponBtn";
import { px2rem } from "../../../../utils/css";

// 宽高固定，自动截取
const ThreeWrapper = styled.div`
	display: grid;
	grid-column-gap: ${px2rem(6)};
	grid-row-gap: ${px2rem(9)};
	overflow-x: scroll;
	/** 隐藏滚动条👇 */
	scrollbar-width: none;
	::-webkit-scrollbar {
		width: 0 !important;
		height: 0 !important;
	}
	/** 隐藏滚动条👆 */
	${(props: { num: number }) => {
		const { num } = props;
		return css`
			// grid-template-columns: repeat(${num}, ${px2rem(120)}); // 设计稿120px
			// grid-template-columns: repeat(${num}, 1fr);
			grid-template: auto / repeat(${num}, 1fr);
		`;
	}}

	img {
		width: 100%;
		object-fit: cover;
	}
`;

export const Three = (props: CouponItemProps) => {
	const { coupons = [], ...others } = props;
	return (
		<ThreeWrapper num={coupons.length}>
			{coupons.map((ele) => {
				return <CouponBtn key={ele.img} coupon={ele} {...others} />;
			})}
		</ThreeWrapper>
	);
};
